import type { Component } from 'vue'
import ESK90075RT from './ESK900-75RT.vue'
import ESK90083RT from './ESK900-83RT.vue'
import ESK90098RT from './ESK900-98RT.vue'
import V700diy75 from './V700diy-75.vue'
import V700diy87 from './V700diy-87.vue'
import V700diy98 from './V700diy-98.vue'
import VT68 from './VT68.vue'

const widgetMap: Readonly<Record<string, Component>> = {
  'ESK900-75RT': ESK90075RT,
  'ESK900-83RT': ESK90083RT,
  'ESK900-98RT': ESK90098RT,
  'V700diy-98': V700diy98,
  'V700diy-87': V700diy87,
  'V700diy-75': V700diy75,
  'A83 Air': ESK90083RT,
  VT68: VT68,
}

export default widgetMap
